import * as types from './types'

// { user_id, flags: { [flagName]: boolean }, timestamp }
const initialState = {
  user_id: null,
  flags: {},
  timestamp: null,
}

const featureFlagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_FEATURE_FLAGS_SUCCESS:
      return {
        user_id: action.payload.userId,
        flags: action.payload.flags,
        timestamp: action.payload.timestamp,
      }

    case types.CLEAR_FEATURE_FLAGS:
      return initialState

    // FETCH_FEATURE_FLAGS_ERROR (and everything else, notably auth's
    // LOGOUT — this reducer never listens for it) intentionally falls
    // through here: the cache from a previous successful fetch persists
    // untouched, both across a failed re-fetch and across logout.
    default:
      return state
  }
}

export default featureFlagsReducer
